import { NavLink, Outlet } from 'react-router-dom';
import { useCelebrationSetting } from '../celebrations';
import { NAV_ITEMS } from '../navigation';
import { useNavCounts } from '../unlogged';

/**
 * Une préoccupation par écran (DESIGN.md) : Pointage porte les séances à pointer,
 * Rapport les factures à traiter, Patients les comptes en attente. À zéro, le point
 * disparaît — il ne signale que ce qui attend.
 *
 * Le nombre ne s'affiche plus : un point rose suffit à dire « il y a quelque chose
 * ici », là où « 7 » se lisait comme un retard (docs/redesign-plus-douce.md,
 * principe 2). Il reste dit à voix haute, pour qui ne voit pas le point.
 */
export function Layout() {
  const counts = useNavCounts();
  // « Douce » ou « joueuse » vient du serveur, pour suivre d'un appareil à l'autre ;
  // la coquille est le seul endroit monté une fois pour toute la session.
  useCelebrationSetting();
  const badges: Record<string, { count: number; hint: string }> = {
    '/pointage': { count: counts.pointage, hint: 'séance(s) à pointer' },
    '/patients': { count: counts.debtors, hint: 'patient(s) à relancer' },
    // Le Rapport porte les deux gestes qui s'y font : boucler le mois, et déclarer
    // le trimestre. Un seul point pour les deux — il dit « viens voir », pas « combien ».
    '/rapport': {
      count: counts.notes + (counts.quarterPending ? 1 : 0),
      hint: counts.quarterPending
        ? 'chose(s) à faire, dont un trimestre à déclarer'
        : 'facture(s) en attente',
    },
  };

  return (
    <div className="shell">
      <nav className="nav" aria-label="Navigation principale">
        <div className="nav__brand">Ergo Calendar</div>
        <ul className="nav__list">
          {NAV_ITEMS.map((item) => {
            const badge = badges[item.path];
            const count = badge?.count ?? 0;
            return (
              <li key={item.path}>
                <NavLink to={item.path} className="nav__link">
                  <span className="nav__icon" aria-hidden="true">
                    {item.icon}
                    {count > 0 && <span className="nav__dot" />}
                  </span>
                  <span className="nav__label">
                    {item.label}
                    {count > 0 && (
                      <span className="visually-hidden">
                        {' '}
                        — {count} {badge?.hint}
                      </span>
                    )}
                  </span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
